/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getDeviceData = /* GraphQL */ `
  query GetDeviceData($id: ID!) {
    getDeviceData(id: $id) {
      id
      DeviceID
      Timestamp
      SystemInfo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDeviceData = /* GraphQL */ `
  query ListDeviceData(
    $filter: ModelDeviceDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDeviceData(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        DeviceID
        Timestamp
        SystemInfo
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
